var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPassIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.4,
    height: 18,
    viewBox: "0 0 14.4 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M11.2,11.9a1.341,1.341,0,0,0-.9,2.349V15.5a.9.9,0,1,0,1.8,0V14.249a1.341,1.341,0,0,0-.9-2.349Zm4.5-3.6V6.5a4.5,4.5,0,1,0-9,0V8.3A2.7,2.7,0,0,0,4,11v6.3A2.7,2.7,0,0,0,6.7,20h9a2.7,2.7,0,0,0,2.7-2.7V11A2.7,2.7,0,0,0,15.7,8.3ZM8.5,6.5a2.7,2.7,0,0,1,5.4,0V8.3H8.5Zm8.1,10.8a.9.9,0,0,1-.9.9h-9a.9.9,0,0,1-.9-.9V11a.9.9,0,0,1,.9-.9h9a.9.9,0,0,1,.9.9Z",
    transform: "translate(-4 -2)",
    opacity: 0.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassIcon);
export default __webpack_public_path__ + "static/media/passIcon.4ced675b7466dbd781ac2f917a54f1fa.svg";
export { ForwardRef as ReactComponent };